import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Contexts/AuthContext/AuthProvider";
import { RotatingSquare } from "react-loader-spinner";

const CryptoCurrencyEdit = () => {
  const { authUser } = useContext(AuthContext);
  const [updateData, setUpdateData] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const refSubmitDis = useRef();

  const { id } = useParams();

  const [image, setImage] = useState(null);

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmitData = (event) => {
    try {
      event.preventDefault();
      setErrorMessage("");
      refSubmitDis.current.setAttribute("disabled", true);
      const formData = new FormData(event.currentTarget);
      const InpuData = Object.fromEntries(formData);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      const userData = { ...InpuData, image: image };
      axios
        .put(
          `https://api.wlfmobile.com/api/admin/crypto/currency/update/${id}`,
          userData,
          config
        )
        .then((response) => {
          event.target.reset();
          toast.success(`${response?.data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setUpdateData(response?.data);
          refSubmitDis.current.removeAttribute("disabled");
        })
        .catch((error) => {
          toast.error(`${error?.response?.data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          refSubmitDis.current.removeAttribute("disabled");
          if (error?.response?.data?.errors) {
            setErrorMessage(error?.response?.data?.errors);
          } else {
            setErrorMessage(error?.response?.data);
          }
        });
    } catch (error) {
      refSubmitDis.current.removeAttribute("disabled");
      if (error?.response?.data?.errors) {
        setErrorMessage(error?.response?.data?.errors);
      } else {
        setErrorMessage(error?.response?.data);
      }
    }
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://api.wlfmobile.com/api/admin/crypto/currency/edit/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data?.data);
        setLoading(false);
      });
  }, [updateData]);

  if (!authUser?.crypto_currency) {
    if (authUser?.crypto_currency === undefined) {
      return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <h1>unauthorized</h1>
        </>
      );
    }
  } else {
    if (loading) {
      return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
    }
    return (
      <>
        <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
          <h6 className="page-title">Update Crypto Currency</h6>
          <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
            <Link
              to="/admin/crypto/currency/list"
              className="btn btn-sm btn-outline-primary"
            >
              <i className="la la-undo"></i> Back
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <form onSubmit={handleSubmitData}>
                <div className="card-body">
                  <div className="payment-method-item">
                    <div className="payment-method-body">
                      <div className="row mt-4">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label for="name" className="required">
                              Name
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="Name"
                                defaultValue={data?.Name}
                                id="name"
                              />
                            </div>
                            {errorMessage?.Name && (
                              <span className="text-danger pt-2">
                                {errorMessage?.Name?.msg}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="symbol" className="required">
                              Symbol
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="Symbol"
                                defaultValue={data?.Symbol}
                                id="symbol"
                              />
                            </div>
                            {errorMessage?.Symbol && (
                              <span className="text-danger pt-2">
                                {errorMessage?.Symbol?.msg}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="currency" className="required">
                              Currency
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="currency"
                                defaultValue={data?.currency}
                                id="currency"
                              />
                            </div>
                            {errorMessage?.currency && (
                              <span className="text-danger pt-2">
                                {errorMessage?.currency?.msg}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="image" className="required">
                          Image
                        </label>
                        <input
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          className="form-control"
                          onChange={handleImage}
                          id="image"
                        />
                        <small className="mt-2  ">
                          Supported files: <b>jpeg, jpg, png.</b> Image will be
                          resized into 400x400 px{" "}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    ref={refSubmitDis}
                    className="btn btn-primary w-100 h-45"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default CryptoCurrencyEdit;
